<div class="upload-files-container" [class.hidden]="!filesVisible">
  @if (!isReadonly) {
    <button
      class="upload-button"
      type="button"
      (click)="onUploadFileClick()"
      [disabled]="checkFilesLimit() || verifyFilesLoaded()"
      >
      @if (!verifyFilesLoaded()) {
        <img src="assets/icons/component_icons/cloud-arrow-up.svg" alt="{{ 'CHAT.MESSAGE.ATTACHMENTS' | translate }}" />
      } @else {
        <div class="spinner"></div>
      }
      <span class="files-limit-info">
        {{ buttonText ?? '(' + fileControls.controls.length + '/' + maxFiles + ')' | translate }}
      </span>
    </button>
  }

  <div class="hidden">
    <app-multi-file-upload
      [allowedMimeTypes]="mimes"
      [forms]="fileControls"
      [maxFiles]="maxFiles"
      [maxFileSize]="maxFileSize"
      [externalClickEvent]="fileApplyObservable"
      [externalClearEvent]="fileDeleteObservable"
      (fileAdded)="onFileAddedHandler($event)"
      >
    </app-multi-file-upload>
  </div>

  @for (fileControl of fileControls.controls; track fileControl; let i = $index) {
    <button type="button" class="file-item" (click)="onFileClick(i)" [attr.aria-label]="'Open ' + (fileControl.value.title || 'file')">
      @if (isWebImage(fileControl.value.mimeType)) {
        <img src="assets/icons/component_icons/eye-black.svg" />
      }
      @if (isPdf(fileControl.value.mimeType)) {
        <img src="assets/icons/component_icons/pdf-icon.svg" />
      }
      <div class="file-item__caption" title="{{ fileControl.value.title }}">
        {{ formatFileCaption(fileControl.value.originalName ?? fileControl.value.caption) }}
      </div>
      @if (!isReadonly) {
        <button
          type="button"
          class="file-item__delete-btn"
          aria-label="Remove file"
          (click)="onDeleteFileClick(i); $event.stopPropagation()"
          [disabled]="isDeleteButtonDisabled"
          >
          <img src="assets/icons/component_icons/close-gray.svg" />
        </button>
      }
    </button>
  }
</div>
